import { ResourceModel, Field } from '@smartsoftware/reflex-core';
import { DexResourceModel } from '../abstracts/dexResource.model';

export class OrderFeeReconciliation extends DexResourceModel {

    @Field(String)
    public lcOrderNumber: string = '';
    @Field(Date)
    public lcOrderDate: Date | null = null;
    @Field(Date)
    public lcDateOrderClosed: Date | null = null;
    @Field(Number)
    public dtControlNumber: number | null = null;
    @Field(String)
    public sourceFilename: string | null = null;
    @Field(Number)
    public courtFees: number = 0;
    @Field(Number)
    public legalConnectServiceFee: number = 0;
    @Field(Number)
    public efmFees: number = 0;
    @Field(Number)
    public paymentFees: number = 0;
    @Field(String)
    public eFileTrxNumber: string | null = null;
    @Field(String)
    public lcCustomerAccountNumber: string | null = null;
    @Field(String)
    public billingCodeRefNum: string | null = null;
    @Field(Boolean)
    public reconciled: boolean = false;
    @Field(Date)
    public dateReconciled: Date | null = null;
    @Field(String)
    public advancedFeeStatus: string = '';
    @Field(String)
    public otherFeeStatus: string = '';
    @Field(String)
    public statusMessage: string | null = null;

    constructor(data?: any) {
        super();
        this.mapData(data);
    }

}
